import { useModalApi } from 'BreetHooks';

import { type TooltipPageType } from './DialogTooltip.helpers';
import DialogTooltipContent from './DialogTooltipContent';

const DialogTooltip = () => {
	const { getModalProps } = useModalApi();

	const { metadata } = getModalProps('tooltip') as { metadata: { page: TooltipPageType } | undefined };

	if (!metadata?.page) return null;

	return <DialogTooltipContent page={metadata.page} />;
};

export default DialogTooltip;
